import styled from 'styled-components'
import { breakpoints } from '@awazevr/design-system.utils.react'

export const StyledSocialProof = styled.div`
  width: 100%;
  display: flex;

  > p {
    flex-grow: 1;
    margin: 0;
    padding: 0;
    width: 100%;
    background-color: ${({ theme }) => theme.ColorStatusConstructive25};
    font-size: ${({ theme }) => theme.FontTextText100MidFontSize}px;
    color: ${({ theme }) => theme.ColorStatusConstructive600};
    padding: 4px 8px;
    font-weight: 600;

    @media only screen and (min-width: ${breakpoints[0]}px) {
      width: auto;
      flex-grow: 0;
    }
  }
`
